
import { BLOCK_SERVICE, BLOCK_SERVICE_REASON, SALON_AVAILABILITY_DETAIL, SALON_AVAILABILITY_STAFF_UPDATE, SALON_AVAILABILITY_UPDATE } from "../Constants/AvailabilityConstants";
import { createGetDataReducer } from "./CommonReducer";

const SalonAvailabilityDetailReducer = createGetDataReducer(SALON_AVAILABILITY_DETAIL);
const SalonAvailabilityUpdateReducer = createGetDataReducer(SALON_AVAILABILITY_UPDATE);
const BlockServiceReasonReducer = createGetDataReducer(BLOCK_SERVICE_REASON);
const BlockServiceReducer = createGetDataReducer(BLOCK_SERVICE);
const StaffAvailabilityUpdateReducer = createGetDataReducer(SALON_AVAILABILITY_STAFF_UPDATE);


export const SalonAvailabilityReducers = {
    SalonAvailabilityState: SalonAvailabilityDetailReducer,
    SalonAvailabilityUpdateState: SalonAvailabilityUpdateReducer,
    BlockServiceReasonState:BlockServiceReasonReducer,
    BlockServiceState:BlockServiceReducer,
    StaffAvailabilityUpdateState:StaffAvailabilityUpdateReducer

}